export const SITE = {
  name: "CLLXTV",
  tagline: "History. Happens. Here.",
  campus: "SATX Campus · San Antonio, TX",
  gatherTime: "Sundays · 9:30 & 11:30 AM starting Aug 2",
};

export const VERSE = {
  text: "And who knows but that you have come to your royal position for such a time as this?",
  ref: "Esther 4:14 (NLT)",
};

// Church Center handles giving and forms so payment and personal info stay
// behind a real login — never collected in this app.
export const LINKS = {
  give: "https://thecllxtv.churchcenter.com/giving",
  events: "https://thecllxtv.churchcenter.com/calendar",
  forms: "https://thecllxtv.churchcenter.com/people/forms",
  serveForm: "https://thecllxtv.churchcenter.com/people/forms",
  servingSchedule: "https://services.planningcenteronline.com",
};

export const SUPPORT_EMAIL = "hello@thecllxtv.com";

export const SPLASH_LINES = [
  "Making history…",
  "There is more…",
  "Living out loud…",
  "Engaging the culture…",
  "Setting the room…",
];
